// 多语言配置文件
// 注意：所有翻译键都使用简体中文作为key，这样便于开发和维护

import { createI18n } from 'vue-i18n'

// 导入语言文件
import zhTw from './locales/zh-tw.js'
import en from './locales/en.js'
import fr from './locales/fr.js'
import pt from './locales/pt.js'
import es from './locales/es.js'
import pl from './locales/pl.js'
import de from './locales/de.js'
import it from './locales/it.js'
import tr from './locales/tr.js'

const messages = {
  'zh-cn': zhTw,
  'zh-tw': zhTw,
  'en': en,
  'fr': fr,
  'pt': pt,
  'es': es,
  'pl': pl,
  'de': de,
  'it': it,
  'tr': tr
}

// 获取租户默认语言（从 localStorage 读取，API 加载后会写入）
const getTenantDefaultLanguage = () => {
  return localStorage.getItem('tenant_default_language') || 'zh-tw'
}

// 获取用户选择的语言，未主动选择则使用租户默认语言
const getDefaultLocale = () => {
  const userChose = localStorage.getItem('user_chose_language') === '1'
  const savedLanguage = localStorage.getItem('selected_language')
  if (userChose && savedLanguage) return savedLanguage
  return getTenantDefaultLanguage()
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API
  locale: getDefaultLocale(),
  fallbackLocale: getTenantDefaultLanguage(),
  messages
})

export default i18n
